import React, { ComponentProps } from 'react';

import Integration from './Integration';
import { IntegrationType } from '../types';

type Props = {
  integration: IntegrationType;
  onViewVersion: ComponentProps<typeof Integration>['onViewVersion'];
  onViewVersions: ComponentProps<typeof Integration>['onViewVersions'];
};

function Container(props: Props) {
  const { integration, onViewVersion, onViewVersions } = props;

  return (
    <Integration
      integration={integration}
      onViewVersion={onViewVersion}
      onViewVersions={onViewVersions}
    />
  );
}

export default Container;
